(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rfn-e15-plus-product-gallery"] && !Shopify.designMode) return;
  try {
    function initializeRfnE15PlusGallery() {
    const gallery = document.querySelector('[data-rfn-e15-gallery]');
    if (!gallery || gallery.dataset.ready) return;
    gallery.dataset.ready = 'true';
    const main = gallery.querySelector('.rfn-e15-gallery__image');
    const thumbnails = Array.from(gallery.querySelectorAll('[data-rfn-e15-thumbnail]'));
    const strip = gallery.querySelector('.rfn-e15-gallery__thumbnails');
    const counter = gallery.querySelector('[data-rfn-e15-count]');
    const variantImages = JSON.parse(gallery.querySelector('[data-rfn-e15-variant-images]').textContent);
    let selected = 0;
    function selectImage(index) {
      selected = (index + thumbnails.length) % thumbnails.length;
      const thumbnail = thumbnails[selected];
      main.srcset = thumbnail.dataset.imageSrcset;
      main.src = thumbnail.dataset.imageSrc;
      main.alt = thumbnail.dataset.imageAlt;
      thumbnails.forEach((button, buttonIndex) => button.setAttribute('aria-current', String(buttonIndex === selected)));
      counter.textContent = `${selected + 1} / ${thumbnails.length}`;
      const thumbRect = thumbnail.getBoundingClientRect();
      const stripRect = strip.getBoundingClientRect();
      if (thumbRect.left < stripRect.left) strip.scrollLeft += thumbRect.left - stripRect.left;
      else if (thumbRect.right > stripRect.right) strip.scrollLeft += thumbRect.right - stripRect.right;
    }
    thumbnails.forEach((button, index) => button.addEventListener('click', () => selectImage(index)));
    gallery.querySelector('[data-rfn-e15-previous]')?.addEventListener('click', () => selectImage(selected - 1));
    gallery.querySelector('[data-rfn-e15-next]')?.addEventListener('click', () => selectImage(selected + 1));
    gallery.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      selectImage(selected + (event.key === 'ArrowRight' ? 1 : -1));
    });
    document.querySelector('#rfn-hero')?.addEventListener('click', (event) => {
      const colorButton = event.target.closest('[data-rfn-color]');
      if (!colorButton) return;
      const imageId = variantImages[colorButton.dataset.rfnColor];
      const index = thumbnails.findIndex((thumbnail) => thumbnail.dataset.imageId === String(imageId));
      if (index >= 0) selectImage(index);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeRfnE15PlusGallery);
  else initializeRfnE15PlusGallery();
  document.addEventListener('shopify:section:load', initializeRfnE15PlusGallery);
  } catch(e) { console.error(e); }
})();

})();
